/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

loadStyles([{"rawString":".ms-GroupedListExample-footer,.ms-GroupedListExample-header{min-width:300px;min-height:40px;line-height:40px;padding-left:16px}.ms-GroupedListExample-name{display:inline-block;overflow:hidden;height:24px;cursor:default;padding:8px;box-sizing:border-box;vertical-align:top;background:0 0;border:none;padding-left:32px}"}]);
/* tslint:enable */